import React from 'react';
import styled from '@emotion/styled';
import { Empty, Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';

export const SearchEmptyState: React.FC = () => {
  const { t } = useTranslation('globalNavigation');

  return (
    <EmptyState data-testid="search-overlay-empty-state">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <>
            <EmptyStateTitle level={3}>
              {t('searchOverlay.noResults.title')}
            </EmptyStateTitle>
            <EmptyStateDescription>
              {t('searchOverlay.noResults.description')}
            </EmptyStateDescription>
          </>
        }
      />
    </EmptyState>
  );
};

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 212px;
  padding: 24px 48px 16px;
  text-align: center;
`;

const EmptyStateTitle = styled(Typography.Title)`
  margin: 0 0 14px;
  font-size: 18px;
  line-height: 26px;
`;

const EmptyStateDescription = styled(Typography.Paragraph)`
  max-width: 390px;
  margin: 0;
  color: rgba(0, 0, 0, 0.72);
  font-size: 14px;
  line-height: 22px;
`;
